import React, {
    useState,
} from 'react';
import { post } from '../Services/http';
import { translate } from '../Services/translation';


const NewsletterOptinContainer = (props) => {
    const [value, setValue] = useState("");
    const [resultMessage, setResultMessage] = useState("");
    const [resultSuccess, setResultSuccess] = useState(true);

    const handleSubmit = async (e) => {
        e.preventDefault();
        var optInModel = {
            Email: value,
            Source: "NewsletterFooterWeb"
        }
        await post('/api/mailchimp/optin', optInModel)
                .then((result) => {
                    setResultSuccess(translate(true)),
                    setResultMessage(translate('newsletter.subscribed'))
                }).catch(() => {
                    setResultSuccess(translate(false)),
                    setResultMessage(translate('newsletter.error'))
                });
    }

    const handleChange = (e) => {
        setValue(e.target.value);
    }

    return(
        <form onSubmit={handleSubmit}>
            {resultMessage && <span className={`newsletter-footer__message newsletter-footer__message--${resultSuccess ? "success" : "error"}`}>{resultMessage}</span>}
            <input id="newsletter-footer__input" aria-label={translate("footer.placeholder")} type="text" value={value} onChange={(e) => handleChange(e)} placeholder={translate("footer.placeholder")} />
            <button type="submit">{translate("footer.send")}</button>
        </form>
    );
}


export default NewsletterOptinContainer;
